<template>
  <div>
<!--    <bridge8-popover-->
<!--      header-prefix="Manager: "-->
<!--      trigger="click"-->
<!--      :obj="row.author"-->
<!--      :text-callback="obj => obj.username"-->
<!--    />-->
    <span>{{ row.author.username }}</span>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'

export default {
  name: 'OrdersTableCellManager',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  components: {
    Bridge8Popover
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellManager.vue